import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AiChatWidget from "@/components/AiChatWidget";
import DefconAlertBanner from "@/components/DefconAlertBanner";
import DefconNuclearPopup from "@/components/DefconNuclearPopup";
import PolicyNoticePopup from "@/components/PolicyNoticePopup";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16">
        <DefconAlertBanner />
        {children}
      </main>
      <Footer />
      <AiChatWidget />
      <DefconNuclearPopup />
      <PolicyNoticePopup />
    </div>
  );
}
